import { useCallback } from 'react'
import { LogOut } from 'lucide-react'
import { authenticationLogout } from '@axilon-apps/domains-identity/state'
import { useAppDispatch } from '@axilon-apps/domains-ontology-ui-state'

import { Button } from '../../../components/ui/button'
import { Card, CardContent } from '../../../components/ui/card'

/**
 * Ends the identity session via the shared logout listener (session delete,
 * OIDC/AuthenticationStorage clear, page reload). Only mount when
 * `isIdentityEnabled()` is true.
 */
export function SignOutCard() {
  const dispatch = useAppDispatch()

  const handleSignOut = useCallback(() => {
    dispatch(authenticationLogout({}))
  }, [dispatch])

  return (
    <Card className="py-2.5">
      <CardContent className="flex items-center justify-between gap-3">
        <div className="flex flex-col gap-0.5">
          <h3 className="text-sm font-semibold text-ink">Account</h3>
          <p className="text-xs text-ink-3">End your signed-in session on this device.</p>
        </div>
        <Button type="button" variant="outline" size="sm" onClick={handleSignOut}>
          <LogOut className="size-3.5" strokeWidth={1.75} />
          Sign out
        </Button>
      </CardContent>
    </Card>
  )
}
